import ToggleBarGroup from './Group.js';
import { uncontrollable } from 'uncontrollable';

var GroupUncontrollable = uncontrollable(ToggleBarGroup, {
  value: 'onChange'
});

export { GroupUncontrollable as default };
//# sourceMappingURL=GroupUncontrollable.js.map
